/* eslint-disable */
//tslint:disable

import { IBargainTermsSchema } from './BargainTermsSchema';
import { IBuildingSchema } from './BuildingSchema';
import { IBusinessShoppingCenterSchema } from './BusinessShoppingCenterSchema';
import { ICplModerationSchema } from './CplModerationSchema';
import { IDrainageSchema } from './DrainageSchema';
import { IElectricitySchema } from './ElectricitySchema';
import { IFlagsSchema } from './FlagsSchema';
import { IGarageSchema } from './GarageSchema';
import { IGasSchema } from './GasSchema';
import { IGeoSchema } from './GeoSchema';
import { IHomeOwnerSchema } from './HomeOwnerSchema';
import { IKPSchema } from './KPSchema';
import { ILandSchema } from './LandSchema';
import { IPhotoSchema } from './PhotoSchema';
import { IMonthlyIncomeSchema } from './MonthlyIncomeSchema';
import { IPhoneSchema } from './PhoneSchema';
import { IPlatformObjectSchema } from './PlatformObjectSchema';
import { IPublishTermsSchema } from './PublishTermsSchema';
import { ICommercialSpecialtySchema } from './CommercialSpecialtySchema';
import { IVideoSchema } from './VideoSchema';
import { IWaterSchema } from './WaterSchema';
import { ISelfEmployedSchema } from './SelfEmployedSchema';

export interface IOfferSchema {
  /** Доступ **/
  accessType?: EAccessType | null;
  /** Доп. линии **/
  additionalPhoneLinesAllowed?: boolean | null;
  /** Площадь комнат, м2 **/
  allRoomsArea?: string | null;
  /** Дата перемещения объявления в архив **/
  archivedDate?: string | null;
  /** Дата освобождения **/
  availableFrom?: string | null;
  /** Количество балконов **/
  balconiesCount?: number | null;
  /** Условия сделки **/
  bargainTerms?: IBargainTermsSchema | null;
  /** Количество спален **/
  bedroomsCount?: number | null;
  /** Количество спальных мест **/
  bedsCount?: number | null;
  /** Информация о здании **/
  building?: IBuildingSchema | null;
  /** БЦ/ТЦ **/
  businessShoppingCenter?: IBusinessShoppingCenterSchema | null;
  /** Кадастровый номер **/
  cadastralNumber?: string | null;
  /** Тип подключенного calltracking-а **/
  callTrackingProvider?: ECallTrackingProvider | null;
  /** Можно частями **/
  canParts?: boolean | null;
  /** Категория объявления **/
  category: ECategory;
  /** Можно с детьми **/
  childrenAllowed?: boolean | null;
  /** ID объявления на ЦИАНе **/
  cianId?: number | null;
  /** ID пользователя в ЦИАНе **/
  cianUserId?: number | null;
  /** Количество совместных санузлов **/
  combinedWcsCount?: number | null;
  /** Состояние **/
  conditionRatingType?: EConditionRatingType | null;
  /** Состояние **/
  conditionType?: EConditionType | null;
  /** Информация для проверки агента по CPL-схеме **/
  cplModeration?: ICplModerationSchema | null;
  /** Отделка **/
  decoration?: EDecoration | null;
  /** Дом подлежит сносу в рамках программы реновации **/
  demolishedInMoscowProgramm?: boolean | null;
  /** Текст объявления **/
  description?: string | null;
  /** Minhash текста объявления **/
  descriptionMinhash?: string | null;
  /** Канализация **/
  drainage?: IDrainageSchema | null;
  /** Объем, м3/сутки **/
  drainageCapacity?: number | null;
  /** Тип канализации **/
  drainageType?: EDrainageType | null;
  /** Подъездные пути **/
  drivewayType?: EDrivewayType | null;
  /** Дата смены статуса объявления **/
  editDate?: string | null;
  /** Электроснабжение **/
  electricity?: IElectricitySchema | null;
  /** Мощность, кВТ **/
  electricityPower?: number | null;
  /** Тип электроснабжения **/
  electricityType?: EElectricityType | null;
  /** Недвижимость **/
  estateType?: EEstateType | null;
  /** Внешний ID **/
  externalId?: string | null;
  /** Ссылка на оригинальное объявление **/
  externalUrl?: string | null;
  /** Флаги состояния объявления **/
  flags?: IFlagsSchema | null;
  /** Тип квартиры **/
  flatType?: EFlatType | null;
  /** Материал полов **/
  floorMaterialType?: EFloorMaterialType | null;
  /** Этаж **/
  floorNumber?: number | null;
  /** Мебель **/
  furniture?: string | null;
  /** Мебель **/
  furniturePresence?: EFurniturePresence | null;
  /** Тип гаража **/
  garage?: IGarageSchema | null;
  /** Газоснабжение **/
  gas?: IGasSchema | null;
  /** Емкость, м3/час **/
  gasCapacity?: number | null;
  /** Давление, Мпа **/
  gasPressure?: number | null;
  /** Тип газоснабжения **/
  gasType?: EGasType | null;
  geo?: IGeoSchema | null;
  /** Есть баня **/
  hasBathhouse?: boolean | null;
  /** Есть ванна **/
  hasBathtub?: boolean | null;
  /** Заселение 24 часа **/
  hasCheckIn_24?: boolean | null;
  /** Есть кондиционер **/
  hasConditioner?: boolean | null;
  /** Есть посудомоечная машина **/
  hasDishwasher?: boolean | null;
  /** Есть канализация **/
  hasDrainage?: boolean | null;
  /** Есть электричество **/
  hasElectricity?: boolean | null;
  /** Есть обременение **/
  hasEncumbrances?: boolean | null;
  /** Есть оборудование **/
  hasEquipment?: boolean | null;
  /** Организация экскурсий **/
  hasExcursions?: boolean | null;
  /** Есть система пожаротушения **/
  hasExtinguishingSystem?: boolean | null;
  /** Есть холодильник **/
  hasFridge?: boolean | null;
  /** Есть мебель (в комнатах для живой) **/
  hasFurniture?: boolean | null;
  /** Есть гараж **/
  hasGarage?: boolean | null;
  /** Есть газ **/
  hasGas?: boolean | null;
  /** Фен **/
  hasHairdryer?: boolean | null;
  /** Есть отопление **/
  hasHeating?: boolean | null;
  /** Есть интернет **/
  hasInternet?: boolean | null;
  /** Есть инвестпроект **/
  hasInvestmentProject?: boolean | null;
  /** Утюг **/
  hasIron?: boolean | null;
  /** Джакузи **/
  hasJacuzzi?: boolean | null;
  /** Есть мебель на кухне **/
  hasKitchenFurniture?: boolean | null;
  /** Есть лифт **/
  hasLift?: boolean | null;
  /** Есть свет **/
  hasLight?: boolean | null;
  /** Есть парковка **/
  hasParking?: boolean | null;
  /** Есть телефон **/
  hasPhone?: boolean | null;
  /** Есть бассейн **/
  hasPool?: boolean | null;
  /** Пандус (есть/нет) **/
  hasRamp?: boolean | null;
  /** Ответственное хранение **/
  hasSafeCustody?: boolean | null;
  /** Документы командированным **/
  hasSecondedDocs?: boolean | null;
  /** Есть охрана **/
  hasSecurity?: boolean | null;
  /** Есть витринные окна **/
  hasShopWindows?: boolean | null;
  /** Есть душевая кабина **/
  hasShower?: boolean | null;
  /** Чай-кофе-сахар **/
  hasTeaCoffeeSugar?: boolean | null;
  /** Трансфер **/
  hasTransfer?: boolean | null;
  /** Транспортные услуги **/
  hasTransportServices?: boolean | null;
  /** Есть телевизор **/
  hasTv?: boolean | null;
  /** Есть стиральная машина **/
  hasWasher?: boolean | null;
  /** Есть водоснабжение **/
  hasWater?: boolean | null;
  /** Есть Wi-Fi **/
  hasWifi?: boolean | null;
  /** Платные ТВ-каналы **/
  hasWiredInternet?: boolean | null;
  /** Информация о собственнике **/
  homeOwner?: IHomeOwnerSchema | null;
  /** ID объявления в Realty **/
  id?: number | null;
  /** Вход **/
  inputType?: EInputType | null;
  /** Апартаменты **/
  isApartments?: boolean | null;
  /** Объявление от собственника **/
  isByHomeowner?: boolean | null;
  /** Таможня **/
  isCustoms?: boolean | null;
  /** Подключен ли колтрекинг **/
  isEnabledCallTracking?: boolean | null;
  /** Объявление закрытой базы **/
  isInHiddenBase?: boolean | null;
  /** Юр. адрес предоставляется (да/нет) **/
  isLegalAddressProvided?: boolean | null;
  /** Помещение занято **/
  isOccupied?: boolean | null;
  /** Пентхаус **/
  isPenthouse?: boolean | null;
  /** Площадь кухни, м2 **/
  kitchenArea?: number | null;
  /** Коттеджный поселок **/
  kp?: IKPSchema | null;
  /** Информация об участке **/
  land?: ILandSchema | null;
  /** Планировка **/
  layout?: ELayout | null;
  /** Планировка **/
  layoutPhoto?: IPhotoSchema | null;
  /** Инфраструктура и досуг **/
  leisure?: string | null;
  /** Жилая площадь, м2 **/
  livingArea?: number | null;
  /** Количество лоджий **/
  loggiasCount?: number | null;
  /** Площадь до **/
  maxArea?: number | null;
  /** Площадь от **/
  minArea?: number | null;
  /** Месячная прибыль **/
  monthlyIncome?: IMonthlyIncomeSchema | null;
  /** Наименование **/
  name?: string | null;
  /** Временный ID объявления/черновика (GUID) **/
  objectGuid: string;
  /** Вид разрешенного использования (ВРИ) **/
  permittedUseType?: EPermittedUseType | null;
  /** Можно с животными **/
  petsAllowed?: boolean | null;
  /** Кол-во телефонных линий **/
  phoneLinesCount?: number | null;
  /** Телефон **/
  phones?: IPhoneSchema[] | null;
  /** Фотография объекта **/
  photos?: IPhotoSchema[] | null;
  /** Тип помещения **/
  placementType?: EPlacementType | null;
  /** Платформа подачи объявления **/
  platform?: IPlatformObjectSchema | null;
  /** Возможно изменить ВРИ **/
  possibleToChangePermittedUseType?: boolean | null;
  /** Проектная декларация **/
  projectDeclarationUrl?: string | null;
  /** Тип недвижимости **/
  propertyType?: EPropertyType | null;
  /** Условия размещения объявления **/
  publishTerms?: IPublishTermsSchema | null;
  /** Realty ID пользователя, из под которого показывается объявление (в случае xml выгрузки id суб-агента) **/
  publishedUserId?: number | null;
  /** Тип ремонта **/
  repairType?: ERepairType | null;
  /** Площадь комнаты (комната, койко-место) **/
  roomArea?: number | null;
  /** Тип комнаты (комната) **/
  roomType?: ERoomType | null;
  /** Площадь комнат **/
  roomsArea?: number | null;
  /** Количество комнат **/
  roomsCount?: number | null;
  /** Право собственности **/
  hasOwnershipRight?: boolean | null;
  /** Узаконенная планировка **/
  isLayoutApproved?: boolean | null;
  /** Количество комнат в продажу/аренду **/
  roomsForSaleCount?: number | null;
  /** Количество раздельных санузлов **/
  separateWcsCount?: number | null;
  /** Название коттеджного поселка **/
  settlementName?: string | null;
  /** Размер доли (доля в квартире, доля в доме) **/
  shareAmount?: string | null;
  /** Возможное назначение **/
  specialty?: ICommercialSpecialtySchema | null;
  /** Статус объявления **/
  status: EStatus;
  /** Номер налоговой **/
  taxNumber?: number | null;
  /** Общая площадь, м2 **/
  totalArea?: number | null;
  /** ID пользователя в Realty **/
  userId?: number | null;
  /** Видео **/
  videos?: IVideoSchema[] | null;
  /** Водоснабжение **/
  water?: IWaterSchema | null;
  /** Объем, м3/сутки **/
  waterCapacity?: number | null;
  /** Кол-во мокрых точек **/
  waterPipesCount?: number | null;
  /** Тип водоснабжения **/
  waterType?: EWaterType | null;
  /** Расположение санузла **/
  wcLocationType?: EWcLocationType | null;
  /** Тип санузла (комната) **/
  wcType?: EWcType | null;
  /** Куда выходят окна **/
  windowsViewType?: EWindowsViewType | null;
  /** Доступна аренда части дома посуточно */
  isRentByParts?: boolean | null;
  /** Условия аренды части дома посуточно */
  rentByPartsDescription?: string | null;
  /** Данные самозанятого */
  selfEmployedData?: ISelfEmployedSchema | null;
  /** Публикаци на других площадках **/
  multiposting: IMultiposting;
}

export interface IMultiposting {
  enabled?: boolean;
}

export enum EAccessType {
  /** Свободный **/
  Free = 'free',
  /** Пропускная система **/
  PassSystem = 'passSystem',
}
export enum ECallTrackingProvider {
  /** Билайн **/
  Beeline = 'beeline',
  /** MTT **/
  Mtt = 'mtt',
}
export enum ECategory {
  /** Аренда койко-места **/
  BedRent = 'bedRent',
  /** Аренда здания **/
  BuildingRent = 'buildingRent',
  /** Продажа здания **/
  BuildingSale = 'buildingSale',
  /** Аренда готового бизнеса **/
  BusinessRent = 'businessRent',
  /** Продажа готового бизнеса **/
  BusinessSale = 'businessSale',
  /** Аренда автосервис **/
  CarServiceRent = 'carServiceRent',
  /** Продажа автосервиса **/
  CarServiceSale = 'carServiceSale',
  /** Аренда коммерческой земли **/
  CommercialLandRent = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  CommercialLandSale = 'commercialLandSale',
  /** Аренда коттеджа **/
  CottageRent = 'cottageRent',
  /** Продажа коттеджа **/
  CottageSale = 'cottageSale',
  /** Посуточная аренда койко-места **/
  DailyBedRent = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  DailyFlatRent = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  DailyHouseRent = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  DailyRoomRent = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  DomesticServicesRent = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  DomesticServicesSale = 'domesticServicesSale',
  /** Аренда квартиры **/
  FlatRent = 'flatRent',
  /** Продажа квартиры **/
  FlatSale = 'flatSale',
  /** Продажа доли в квартире **/
  FlatShareSale = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  FreeAppointmentObjectRent = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  FreeAppointmentObjectSale = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  GarageRent = 'garageRent',
  /** Продажа гаража **/
  GarageSale = 'garageSale',
  /** Аренда дома/дачи **/
  HouseRent = 'houseRent',
  /** Продажа дома/дачи **/
  HouseSale = 'houseSale',
  /** Аренда части дома **/
  HouseShareRent = 'houseShareRent',
  /** Продажа части дома **/
  HouseShareSale = 'houseShareSale',
  /** Аренда производства **/
  IndustryRent = 'industryRent',
  /** Продажа производство **/
  IndustrySale = 'industrySale',
  /** Продажа участка **/
  LandSale = 'landSale',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Аренда офиса **/
  OfficeRent = 'officeRent',
  /** Продажа офиса **/
  OfficeSale = 'officeSale',
  /** Аренда общепита **/
  PublicCateringRent = 'publicCateringRent',
  /** Продажа общепита **/
  PublicCateringSale = 'publicCateringSale',
  /** Аренда комнаты **/
  RoomRent = 'roomRent',
  /** Продажа комнаты **/
  RoomSale = 'roomSale',
  /** Аренда торговой площади **/
  ShoppingAreaRent = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  ShoppingAreaSale = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  TownhouseRent = 'townhouseRent',
  /** Продажа таунхауса **/
  TownhouseSale = 'townhouseSale',
  /** Аренда склада **/
  WarehouseRent = 'warehouseRent',
  /** Продажа склада **/
  WarehouseSale = 'warehouseSale',
}
export enum EConditionRatingType {
  /** Отличное **/
  Excellent = 'excellent',
  /** Хорошее **/
  Good = 'good',
  /** Удовлетворительное **/
  Satisfactory = 'satisfactory',
}
export enum EConditionType {
  /** Требуется косметический ремонт **/
  CosmeticRepairsRequired = 'cosmeticRepairsRequired',
  /** Дизайнерский ремонт **/
  Design = 'design',
  /** Под чистовую отделку **/
  Finishing = 'finishing',
  /** Требуется капитальный ремонт **/
  MajorRepairsRequired = 'majorRepairsRequired',
  /** Офисная отделка **/
  Office = 'office',
  /** Типовой ремонт **/
  Typical = 'typical',
}
export enum EDecoration {
  /** Чистовая **/
  Fine = 'fine',
  /** Черновая **/
  Rough = 'rough',
  /** Без отделки **/
  Without = 'without',
}
export enum EDrainageType {
  /** Автономная **/
  Autonomous = 'autonomous',
  /** Центральная **/
  Central = 'central',
  /** Септик **/
  SepticTank = 'septicTank',
  /** Ливневая **/
  Storm = 'storm',
  /** Очистные сооружения **/
  TreatmentFacilities = 'treatmentFacilities',
}
export enum EDrivewayType {
  /** Асфальтированная дорога **/
  Asphalt = 'asphalt',
  /** Грунтовая дорога **/
  Ground = 'ground',
  /** Нет **/
  No = 'no',
}
export enum EElectricityType {
  /** По границе участка **/
  Border = 'border',
  /** На участке **/
  Location = 'location',
  /** Нет **/
  No = 'no',
}
export enum EEstateType {
  /** В собственности **/
  Owned = 'owned',
  /** В аренде **/
  Rent = 'rent',
}
export enum EFlatType {
  /** Свободная планировка **/
  OpenPlan = 'openPlan',
  /** Комнаты **/
  Rooms = 'rooms',
  /** Студия **/
  Studio = 'studio',
}
export enum EFloorMaterialType {
  /** Асфальт **/
  Asphalt = 'asphalt',
  /** Бетон **/
  Concrete = 'concrete',
  /** Ламинат **/
  Laminate = 'laminate',
  /** Линолеум **/
  Linoleum = 'linoleum',
  /** Полимерный **/
  Polymeric = 'polymeric',
  /** Железобетон **/
  ReinforcedConcrete = 'reinforcedConcrete',
  /** Наливной пол **/
  SelfLeveling = 'selfLeveling',
  /** Плитка **/
  Tile = 'tile',
  /** Дерево **/
  Wood = 'wood',
}
export enum EFurniturePresence {
  /** Нет **/
  No = 'no',
  /** По желанию **/
  Optional = 'optional',
  /** Есть **/
  Yes = 'yes',
}
export enum EGasType {
  /** По границе участка **/
  Border = 'border',
  /** На участке **/
  Location = 'location',
  /** Нет **/
  No = 'no',
}
export enum EInputType {
  /** Общий с улицы **/
  CommonFromStreet = 'commonFromStreet',
  /** Общий со двора **/
  CommonFromYard = 'commonFromYard',
  /** Отдельный с улицы **/
  SeparateFromStreet = 'separateFromStreet',
  /** Отдельный со двора **/
  SeparateFromYard = 'separateFromYard',
}
export enum ELayout {
  /** Кабинетная **/
  Cabinet = 'cabinet',
  /** Коридорная **/
  Corridorplan = 'corridorplan',
  /** Смешанная **/
  Mixed = 'mixed',
  /** Открытая **/
  OpenSpace = 'openSpace',
}
export enum EPermittedUseType {
  /** Cельскохозяйственное использование **/
  Agricultural = 'agricultural',
  /** Деловое управление **/
  BusinessManagement = 'businessManagement',
  /** Общее пользование территории **/
  CommonUseArea = 'commonUseArea',
  /** Высотная застройка **/
  HighriseBuildings = 'highriseBuildings',
  /** Гостиничное обслуживание **/
  HotelAmenities = 'hotelAmenities',
  /** Индивидуальное жилищное строительство (ИЖС) **/
  IndividualHousingConstruction = 'individualHousingConstruction',
  /** Промышленность **/
  Industry = 'industry',
  /** Отдых (рекреация) **/
  Leisure = 'leisure',
  /** Малоэтажное жилищное строительство (МЖС) **/
  LowriseHousing = 'lowriseHousing',
  /** Общественное использование объектов капитального строительства **/
  PublicUseOfCapitalConstruction = 'publicUseOfCapitalConstruction',
  /** Обслуживание автотранспорта **/
  ServiceVehicles = 'serviceVehicles',
  /** Торговые центры **/
  ShoppingCenters = 'shoppingCenters',
  /** Склады **/
  Warehouses = 'warehouses',
}
export enum EPlacementType {
  /** Помещение в торговом комплексе **/
  ShoppingMall = 'shoppingMall',
  /** Street retail **/
  StreetRetail = 'streetRetail',
}
export enum EPropertyType {
  /** здание **/
  Building = 'building',
  /** помещение свободного назначения **/
  FreeAppointment = 'freeAppointment',
  /** гараж **/
  Garage = 'garage',
  /** производство **/
  Industry = 'industry',
  /** земля **/
  Land = 'land',
  /** офис **/
  Office = 'office',
  /** торговая площадь **/
  ShoppingArea = 'shoppingArea',
  /** склад **/
  Warehouse = 'warehouse',
}
export enum ERepairType {
  /** Косметический **/
  Cosmetic = 'cosmetic',
  /** Дизайнерский **/
  Design = 'design',
  /** Евроремонт **/
  Euro = 'euro',
  /** Без ремонта **/
  No = 'no',
}
export enum ERoomType {
  /** Оба варианта **/
  Both = 'both',
  /** Смежная **/
  Combined = 'combined',
  /** Изолированная **/
  Separate = 'separate',
}
export enum EStatus {
  /** Заблокировано **/
  Blocked = 'blocked',
  /** Деактивировано **/
  Deactivated = 'deactivated',
  /** Удалено **/
  Deleted = 'deleted',
  /** Черновик **/
  Draft = 'draft',
  /** Промодерировано **/
  Moderate = 'moderate',
  /** Опубликовано **/
  Published = 'published',
  /** Отклонено **/
  Refused = 'refused',
  /** Удалено модератором **/
  RemovedByModerator = 'removedByModerator',
  /** Продано **/
  Sold = 'sold',
}
export enum EWaterType {
  /** Автономное **/
  Autonomous = 'autonomous',
  /** Центральное **/
  Central = 'central',
  /** Водонапорная станция **/
  PumpingStation = 'pumpingStation',
  /** Водозаборный узел **/
  WaterIntakeFacility = 'waterIntakeFacility',
  /** Водонапорная башня **/
  WaterTower = 'waterTower',
}
export enum EWcLocationType {
  /** В доме **/
  Indoors = 'indoors',
  /** На улице **/
  Outdoors = 'outdoors',
}
export enum EWcType {
  /** Совмещенный **/
  Combined = 'combined',
  /** Раздельный **/
  Separate = 'separate',
}
export enum EWindowsViewType {
  /** На улицу **/
  Street = 'street',
  /** Во двор **/
  Yard = 'yard',
  /** На улицу и двор **/
  YardAndStreet = 'yardAndStreet',
}
